import { LoadableLazy } from '@confluence/loadable';

export const MovePageDialog = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-MovePageDialog" */ './MovePageDialog'))
			.MovePageDialog,
});
